module.exports = __webpack_public_path__ + "assets/img/36_574_big.57db3dff.jpg";